// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__Ln+XZ","headerWrapper":"Header_headerWrapper__91w96","dateWrapper":"Header_dateWrapper__wqn7s","smallHeader":"Header_smallHeader__gk6EQ"};